export default "__VITE_ASSET__BRG4BLDW__"